import { render, staticRenderFns } from "./proofs.vue?vue&type=template&id=5008e473&"
import script from "./proofs.vue?vue&type=script&lang=js&"
export * from "./proofs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports